import { RadioGroup } from '@headlessui/react';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import useAssets from '~hooks/useAssets';
import { updateFileContributionType } from '~modules/media-library/controller/thunks/contribute';
import { AssetId } from '~modules/media-library/model/Asset';

interface SelectAssetTypeProps {
  assetId?: AssetId;
  onStepComplete?: () => void;
}

function SelectAssetType({ onStepComplete, assetId }: SelectAssetTypeProps) {
  const mediaTypes = ['image', 'document'];
  const [selected, setSelected] = useState('');

  const dispatch = useDispatch();
  const { getAssetById } = useAssets();

  const asset = getAssetById(assetId);

  const onChangeOfType = (type: string) => {
    dispatch(updateFileContributionType(type));
  };

  useEffect(() => {
    if (asset) {
      const type = asset.type.toLowerCase();
      setSelected(type);
      dispatch(updateFileContributionType(type));
    }
  }, [asset, dispatch]);

  return (
    <div>
      <div>
        <h3>What media type is it?</h3>
        <div className="u-margin-top-lg">
          <RadioGroup
            value={selected}
            onChange={value => {
              setSelected(value);
              onChangeOfType(value);
            }}
          >
            <div className="flex flex-wrap">
              {mediaTypes.map(type => (
                <RadioGroup.Option
                  key={type}
                  value={type}
                  className={({ active, checked }) =>
                    `${active ? 'ring-2 ring-white ring-opacity-60 ring-offset-2 ring-offset-sky-300' : ''}
                  ${checked ? 'bg-gray-200 text-gray-700' : 'bg-white'}
                    relative flex cursor-pointer rounded-lg px-3 py-3 shadow-md focus:outline-none m-2 w-full border-solid border border-silver`
                  }
                >
                  {({ checked }) => (
                    <>
                      <div className="flex w-full items-center justify-between">
                        <div className="flex items-center">
                          <div className="text-sm">
                            <RadioGroup.Label
                              as="p"
                              className={`capitalize  ${checked ? 'text-gray-700' : 'text-gray-900'}`}
                            >
                              {type}
                            </RadioGroup.Label>
                          </div>
                        </div>
                        {checked && (
                          <div className="pl-2 shrink-0 text-gray-700">
                            <CheckIcon className="h-6 w-6" />
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </RadioGroup.Option>
              ))}
            </div>
          </RadioGroup>
        </div>
      </div>
      <div className="flex my-4">
        <button
          type="button"
          className="button c-button c-button--dark u-padding-horizontal-lg ml-2"
          onClick={onStepComplete}
        >
          Continue
        </button>
      </div>
    </div>
  );
}

const CheckIcon = props => {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx={12} cy={12} r={12} fill="#000000" opacity="0.2" />
      <path d="M7 13l3 3 7-7" stroke="#000000" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default SelectAssetType;
